'use client'

import { useEffect } from "react"
import { XMarkIcon } from "@heroicons/react/20/solid"
import Button from "@/app/components/Button"
import classNames from "classnames"

type Props = {
    children: React.ReactNode
    className?: string
    contentClassName?: string
    close?: Function
}

export default function Popup(props: Props) {

    const { children, className, contentClassName, close } = props

    useEffect(() => {
        document.body.style.overflow = 'hidden'

        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [])

    return (
        <div
            className={`popup ${className}`}
            onClick={(e) => {
                if (e.target === e.currentTarget && close) {
                    close()
                }
            }}
        >
            <div className={`popup-content ${contentClassName}`}>
                { close &&
                    <Button
                        className="absolute flex-center bg-main rounded-full w-7 h-7 -top-3 -right-3"
                        onClick={close}
                    >
                        <XMarkIcon className="w-5 fill-white" />
                    </Button>
                }
                {children}
            </div>
        </div>
    )
}

type PopupContentProps = {
    children: React.ReactNode
    className?: string
}
const Title = ({ children, className }: PopupContentProps) => {
    return (
        <div className={classNames('text-[1.25rem] text-main-600 font-bold text-center mb-4', className)}>
            {children}
        </div>
    )
}
const Content = ({ children, className }: PopupContentProps) => {
    return (
        <div className={classNames('text-black-800 mb-6 text-center', className)}>
            {children}
        </div>
    )
}

Popup.Title = Title
Popup.Content = Content